// 选型快速搜索后，记录筛选条件
const state = {
  // 品牌
  currentBrands: null,
  // 风机需要获取该值，默认为SINGLE_SPEED
  speedValue: 'SINGLE_SPEED',
  curveSearchValues: [],
  propertySearchValues: [],
}
const getters = {
  currentBrands: (state) => state.currentBrands,
  speedValue: (state) => state.speedValue,
  curveSearchValues: (state) => state.curveSearchValues,
  // 处理列表页性能搜索组件中所需的初始值
  initCurveSearchValue: (state) => {
    const curveSearchValues = state.curveSearchValues
    const curveForm = {}
    const deviation = {}
    curveSearchValues.forEach((item) => {
      const code = item.code
      curveForm[code] = item.value
      deviation[code] = item.deviationRate
    })
    return { curveForm, deviation }
  },
  propertySearchValues: (state) => state.propertySearchValues,
  // 处理列表页筛选条件组件中所需的初始值
  initPropertySearchValue: (state) => {
    const propertySearchValues = state.propertySearchValues
    const form = {}
    if (!(propertySearchValues && propertySearchValues.length > 0)) {
      return form
    }
    propertySearchValues.forEach((item) => {
      if (form[item.code]) {
        form[item.code].push({ code: item.valueCode, name: item.valueName })
      } else {
        form[item.code] = [{ code: item.valueCode, name: item.valueName }]
      }
    })
    return form
  },
}
const mutations = {
  setSpeedValue(state, data) {
    state.speedValue = data
  },
  setCurrentBrands(state, data) {
    state.currentBrands = data
  },
  setCurveSearchValues(state, data) {
    state.curveSearchValues = data || []
  },
  setPropertySearchValues(state, data) {
    state.propertySearchValues = data || []
  },
}
const actions = {}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
